import { render, staticRenderFns } from "./OffersGrid.vue?vue&type=template&id=0be13a8a&scoped=true"
import script from "./OffersGrid.vue?vue&type=script&lang=js"
export * from "./OffersGrid.vue?vue&type=script&lang=js"
import style0 from "./OffersGrid.vue?vue&type=style&index=0&id=0be13a8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be13a8a",
  null
  
)

export default component.exports